exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Notification */\n.rounded-corner {\n  border-radius: 5px;\n}\n.toaster-container {\n  position: fixed;\n  z-index: 20000;\n  right: 10px;\n  top: 10px;\n}\n.toaster {\n  background-color: #00a478;\n  color: white;\n  box-shadow: 2px 2px 12px #222222;\n  padding: 20px;\n  margin-bottom: 10px;\n  width: 200px;\n}\n.rounded-corner .toaster.success {\n  background-color: #00a478;\n}\n.toaster.danger {\n  background-color: #ff4d4d;\n}\n", ""]);

// exports
